import PublishUtils, { ListSerializationFormat } from '../../helpers/PublishUtils'

export interface Serializer<T> {
  serialize(value: T): string | null
  deserialize(str: string | null): T
}

export class NoopStringSerializer implements Serializer<string | null> {
  public serialize(value: string | null): string | null {
    return value
  }

  public deserialize(str: string | null): string | null {
    return str
  }
}

export class StringListSerializer implements Serializer<string[]> {
  private readonly format: ListSerializationFormat | null | undefined

  public constructor(format: ListSerializationFormat | null | undefined) {
    this.format = format
  }

  public serialize(value: string[]): string | null {
    return PublishUtils.getListAsSingleValue(this.format, value)
  }

  public deserialize(str: string | null): string[] {
    if (str == null) return []
    return PublishUtils.parseMultiplePropValue(this.format, str)
  }
}
